import { Api } from 'models/services/api';
import { DeletePosSystemQuery } from 'models/services/graphql';

import { PosSystemData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeletePosSystem($id: ID!) {
    ${DeletePosSystemQuery}
  }
`;

type ResponseData = {
  data: {
    deletePosSystem: PosSystemData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: PosSystemData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw 'invalid response';
    const document = api.response.data.deletePosSystem;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };